import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import { Container } from '@material-ui/core'

import { Flexbox, Logo, NavLink, Text } from '~/components/shared'

import { isAuthorized } from '~/state/modules/user'
import { AppState } from '~/state/store'

import ROUTES from '~/constants/routes'

import msg from './footer.mesagess'
import { useDesktopStyles } from './Footer.styles'

const FooterDesktop: React.FC = () => {
  const s = useDesktopStyles()
  const uiSettings = useSelector((state: AppState) => state.user?.ui_setting)

  const isAuth = useSelector(isAuthorized)

  return (
    <footer className={s.root}>
      <Container maxWidth="xl">
        <Flexbox className={isAuth ? s.container_auth : s.container}>
          <Logo src={uiSettings?.logo_link} width={uiSettings?.logo_width} />

          <Flexbox className={s.links}>
            <NavLink href={ROUTES.privacy}>
              <FormattedMessage {...msg.privacy} />
            </NavLink>

            <NavLink href={ROUTES.terms}>
              <FormattedMessage {...msg.terms} />
            </NavLink>
          </Flexbox>

          <Text className={s.text}>
            <FormattedMessage
              {...msg.rightsReserved}
              values={{ year: new Date().getFullYear() }}
            />
          </Text>
        </Flexbox>
      </Container>
    </footer>
  )
}

export default FooterDesktop
